<app-shell>
    <div #content></div>
</app-shell>
